import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { faqItems } from '../data/content';
import Icon from './Icons';
import Reveal from './Reveal';
import './Faq.css';

/** FAQ – akordeón. Otázky a odpovede sa upravujú v src/data/content.js. */
export default function Faq() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="section" id="faq">
      <div className="container container--narrow">
        <Reveal className="section-heading">
          <span className="eyebrow">FAQ</span>
          <h2>Časté otázky</h2>
        </Reveal>

        <div className="faq">
          {faqItems.map((item, index) => {
            const open = openIndex === index;
            return (
              <Reveal key={`${index}-${item.question}`} delay={Math.min(index * 0.04, 0.25)}>
                <div className={`faq__item ${open ? 'faq__item--open' : ''}`}>
                  <h3>
                    <button
                      className="faq__question"
                      onClick={() => setOpenIndex(open ? null : index)}
                      aria-expanded={open}
                      aria-controls={`faq-answer-${index}`}
                    >
                      {item.question}
                      <Icon name="chevron" size={20} className="faq__chevron" />
                    </button>
                  </h3>
                  <AnimatePresence initial={false}>
                    {open && (
                      <motion.div
                        id={`faq-answer-${index}`}
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: 'auto', opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.3, ease: 'easeInOut' }}
                        style={{ overflow: 'hidden' }}
                      >
                        <p className="faq__answer">{item.answer}</p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
